export default __webpack_public_path__ + "static/media/scan.31bbfc6b.gif";